// JsFromRoutes CacheKey 274e87bad841244a88067e7bba5c81ea
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  delete: /* #__PURE__ */ definePathHelper('get', '/other_movements/:public_id/delete'),
  create: /* #__PURE__ */ definePathHelper('post', '/other_movements'),
  new: /* #__PURE__ */ definePathHelper('get', '/other_movements/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/other_movements/:public_id/edit'),
  update: /* #__PURE__ */ definePathHelper('patch', '/other_movements/:public_id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/other_movements/:public_id'),
}
